export const API_ENDPOINTS = {
    PROPERTYACTIVITY: "property/activity",
    PROPERTYEXPENSE: "property/expense",
    PROPERTYMETADATA: "property/property_metadata",
    PROPERTYHOSTEDBY: "property/hostedby",
    COMPNAYINVEPDATE: "company",
    DAO: "dao",
}